'use es6';

import PropTypes from 'prop-types';
import React, { forwardRef, useContext } from 'react';
import { hidden } from '../utils/propTypes/decorators';
import { MODAL_USE_CLASSES } from './DialogConstants';
import AbstractModal from './internal/AbstractModal';
import ModalTransition from './internal/ModalTransition';
import UIModalDialog from './UIModalDialog';
import { createPlacementWarning, DropdownContext } from '../context/DropdownContext';
var UIModal = forwardRef(function (props, ref) {
  var _useContext = useContext(DropdownContext),
      shouldLogModalWarning = _useContext.shouldLogModalWarning;

  var _createPlacementWarning = createPlacementWarning(UIModal.displayName);

  if (shouldLogModalWarning) {
    _createPlacementWarning();
  }

  return React.createElement(AbstractModal, Object.assign({}, props, {
    componentName: "UIModal",
    Transition: ModalTransition,
    ref: ref
  }));
});
UIModal.propTypes = Object.assign({}, UIModalDialog.propTypes, {
  ModalDialog: hidden(PropTypes.func),
  onCloseComplete: PropTypes.func,
  onCloseStart: PropTypes.func,
  onOpenComplete: PropTypes.func,
  onOpenStart: PropTypes.func,
  use: PropTypes.oneOf(Object.keys(MODAL_USE_CLASSES)).isRequired,
  _contextual: PropTypes.bool
});
UIModal.defaultProps = Object.assign({}, UIModalDialog.defaultProps, {
  ModalDialog: UIModalDialog,
  _contextual: false
});
UIModal.displayName = 'UIModal';
export default UIModal;